import type { Wallet } from '@/modules/networks/components/wallets-section/wallets-section'

export const WALLETS: Wallet[] = [
  {
    id: '1',
    name: 'Powerhouse Ops',
    address: '0x7cB57B5A97eAbe94205C07890BE4c1aD31E486A8',
    usdsBalance: 1311031,
    skyBalance: 1000000,
  },
  {
    id: '2',
    name: 'Powerhouse Treasury',
    address: '0x9eE79C7C89gCde06427E29012EG6e3cF53G608C',
    usdsBalance: 12000000,
    skyBalance: 5550000,
  },
  {
    id: '3',
    name: 'Workstream Escrow',
    address: '0x588562508937B75d8387937259096521586A8310',
    usdsBalance: 750000,
    skyBalance: 250000,
  },
]
